import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const moonlightEldConfig: TSPConfig = {
  key: 'moonlighteld',
  name: 'Moonlight ELD',
  imageName: 'moonlight_eld',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your Moonlight ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Moonlight ELD Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default moonlightEldConfig;
